export default "__VITE_ASSET__B9Hw0JO8__"